import axios from 'axios';

// Create an Axios instance with base config
const api = axios.create({
  baseURL: process.env.REACT_APP_STRAPI_API_URL, // Base URL from .env
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_STRAPI_TOKEN}`, // Token from .env
  },
});

export const getUpcomingEvent = async (artistId) => {
  try {
    const response = await api.get(`/api/upcoming-event?populate=*`);
    return response.data;
  } catch (error) {
    console.error('Error fetching artist data:', error);
    throw error;
  }
};


export const getGalleryData = async (galleryId) => {
    try {
      const response = await api.get(`/api/galleries/${galleryId}?populate=*`);
      return response.data;
    } catch (error) {
      console.error('Error fetching artist data:', error);
      throw error;
    }
};

export const getGalleries = async () => {
    try {
      const response = await api.get(`/api/galleries/?populate=*&pagination[limit]=100`);
      return response.data;
    } catch (error) {
      console.error('Error fetching artist data:', error);
      throw error;
    }
};


export const getArtworkData = async (artworkId) => {
    try {
      const response = await api.get(`/api/artworks/${artworkId}?populate=*`);
      return response.data;
    } catch (error) {
      console.error('Error fetching artist data:', error);
      throw error;
    }
};

export const getArtworks = async () => {
    try {
      const response = await api.get(`/api/artworks/?populate=*&pagination[limit]=100`);
      return response.data;
    } catch (error) {
      console.error('Error fetching artist data:', error);
      throw error;
    }
};


export const getEventData = async (eventId) => {
    try {
      const response = await api.get(`/api/events/${eventId}?populate=*`);
      return response.data;
    } catch (error) {
      console.error('Error fetching artist data:', error);
      throw error;
    }
};

export const getEvents = async () => {
    try {
      const response = await api.get(`/api/events/?populate=*&pagination[limit]=100`);
      return response.data;
    } catch (error) {
      console.error('Error fetching artist data:', error);
      throw error;
    }
};

// Fetch Menu - Architecture icon only
export const getMenuArchitecture = async () => {
    try {
      const response = await api.get(`/api/menu-architecture?populate=*`);
      return response.data;
    } catch (error) {
      // Only log error if it's not a 404 (which means no content uploaded)
      if (error.response?.status !== 404) {
        console.error('Error fetching menu architecture icon:', error);
      }
      return null; // Return null instead of throwing error
    }
};

// Fetch Menu - Art icon only
export const getMenuArt = async () => {
    try {
      const response = await api.get(`/api/menu-art?populate=*`);
      return response.data;
    } catch (error) {
      // Only log error if it's not a 404 (which means no content uploaded)
      if (error.response?.status !== 404) {
        console.error('Error fetching menu art icon:', error);
      }
      return null; // Return null instead of throwing error
    }
};

// Fetch Menu - Film icon only
export const getMenuFilm = async () => {
    try {
      const response = await api.get(`/api/menu-film?populate=*`);
      return response.data;
    } catch (error) {
      // Only log error if it's not a 404 (which means no content uploaded)
      if (error.response?.status !== 404) {
        console.error('Error fetching menu film icon:', error);
      }
      return null; // Return null instead of throwing error
    }
};

// Fetch Menu - Literature icon only
export const getMenuLiterature = async () => {
    try {
      const response = await api.get(`/api/menu-literature?populate=*`);
      return response.data;
    } catch (error) {
      // Only log error if it's not a 404 (which means no content uploaded)
      if (error.response?.status !== 404) {
        console.error('Error fetching menu literature icon:', error);
      }
      return null; // Return null instead of throwing error
    }
};

// Fetch all menu items at once
export const getAllMenuItems = async () => {
    try {
      const [architecture, art, film, literature] = await Promise.all([
        getMenuArchitecture(),
        getMenuArt(),
        getMenuFilm(),
        getMenuLiterature()
      ]);

      return {
        architecture,
        art,
        film,
        literature
      };
    } catch (error) {
      console.error('Error fetching all menu items:', error);
      // Return empty object instead of throwing error
      return {
        architecture: null,
        art: null,
        film: null,
        literature: null
      };
    }
};

